import axios from "axios";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";

export const getAzureConsoleLogsApi = async (searchJson, provider) => {
  try {

    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/console-logs" : "container-logs";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      params: searchJson
    });
    console.log(searchJson, 'kkkkkkkkk')
    return response;
  } catch (e) {
    return [];
  }
};


export const getAzureContainerAppNameApi = async (param) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem('api_token');
    const response = await axios({
      method: "GET",
      url: `${API_URL}app_containers`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};